import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/navbar';
import { Footer } from './components/layout/footer';
import { FormPopup } from './components/forms/FormPopup';
import HomePage from './pages/home';
import AboutPage from './pages/about';
import ServicesPage from './pages/services';
import CommercialPage from './pages/commercial';
import MedicalPage from './pages/medical';
import PricingPage from './pages/pricing';
import BlogPage from './pages/blog';
import TestimonialsPage from './pages/testimonials';
import ContactPage from './pages/contact';
import SignInPage from './pages/auth/sign-in';
import VerificationPage from './pages/auth/verification';
import CheckoutPage from './pages/checkout';
import ServiceAreasPage from './pages/service-areas';
import AltamonteSpringsPage from './pages/service-areas/AltamonteSpringsPage';
import WinterParkPage from './pages/service-areas/WinterParkPage';
import ApopkaPage from './pages/service-areas/ApopkaPage';
import CasselberryPage from './pages/service-areas/CasselberryPage';
import LakeMaryPage from './pages/service-areas/LakeMaryPage';
import SanfordPage from './pages/service-areas/SanfordPage';
import OviedoPage from './pages/service-areas/OviedoPage';
import KissimmeePage from './pages/service-areas/KissimmeePage';
import OcoeePage from './pages/service-areas/OcoeePage';
import WinterGardenPage from './pages/service-areas/WinterGardenPage';
import LongwoodPage from './pages/service-areas/LongwoodPage';
import OrlandoPage from './pages/service-areas/OrlandoPage';
import ClermontPage from './pages/service-areas/ClermontPage';
import MaitlandPage from './pages/service-areas/MaitlandPage';
import WinterSpringsPage from './pages/service-areas/WinterSpringsPage';
import PrivacyPage from './pages/privacy';
import TermsPage from './pages/terms';

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/medical" element={<MedicalPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/verify" element={<VerificationPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/cleaning-services/altamonte-springs-fl" element={<AltamonteSpringsPage />} />
          <Route path="/cleaning-services/winter-park-fl" element={<WinterParkPage />} />
          <Route path="/cleaning-services/apopka-fl" element={<ApopkaPage />} />
          <Route path="/cleaning-services/casselberry-fl" element={<CasselberryPage />} />
          <Route path="/cleaning-services/lake-mary-fl" element={<LakeMaryPage />} />
          <Route path="/cleaning-services/sanford-fl" element={<SanfordPage />} />
          <Route path="/cleaning-services/oviedo-fl" element={<OviedoPage />} />
          <Route path="/cleaning-services/kissimmee-fl" element={<KissimmeePage />} />
          <Route path="/cleaning-services/ocoee-fl" element={<OcoeePage />} />
          <Route path="/cleaning-services/winter-garden-fl" element={<WinterGardenPage />} />
          <Route path="/cleaning-services/longwood-fl" element={<LongwoodPage />} />
          <Route path="/cleaning-services/orlando-fl" element={<OrlandoPage />} />
          <Route path="/cleaning-services/clermont-fl" element={<ClermontPage />} />
          <Route path="/cleaning-services/maitland-fl" element={<MaitlandPage />} />
          <Route path="/cleaning-services/winter-springs-fl" element={<WinterSpringsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <Footer />
      </div>
      <FormPopup />
    </Router>
  );
}

export default App;
